import React, { useState, useEffect, useRef } from "react";
import { Table, Badge, Dropdown } from "react-bootstrap";
import {
  getUserList,
  blockUser,
  deleteUser,
  getPremiumUserList,
} from "../../services/UserServices/UserService";
import Spinner from "../components/Common/Spinner";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";
import Pagination from "../components/Common/Pagination";
import GenderAvatar from "../components/Common/GenderAvatar";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import dummmyImg from "../../images/profile/images1.png";
import * as XLSX from "xlsx";
import { useDispatch } from "react-redux";
import { selectConversationNull } from "../../store/actions/SessionActions";
import {
  ageFilterPost,
  resetFilterPost,
} from "../../store/actions/FilterActions";
import { useSelector } from "react-redux";
import CountryPicker from "../components/Modal/CountryPicker";
import useFilterPage from "../hooks/useFilterPage";

const PremiumUserPastTable = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useFilterPage("members-past");
  const imgBaseURl = process.env.REACT_APP_IMAGE_BASEURL;
  const [loader, setLoader] = useState(false);
  const [users, setUsers] = useState([]);
  const [listLength, setListLength] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [imageForView, setImageForView] = useState("");
  const [view, setView] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    location?.state?.page ? location?.state?.page : 0
  );
  const [search, setSearch] = useState(
    location?.state?.search ? location?.state?.search : ""
  );
  const [initialFetch, setInitialFetch] = useState(true);
  const [gender, setGender] = useState(
    location?.state?.gender ? location?.state?.gender : "all"
  );
  const [type, setType] = useState(
    location?.state?.type ? location?.state?.type : "all"
  );
  const [status, setStatus] = useState(
    location?.state?.status ? location?.state?.status : "all"
  );
  const [isFormFilled, setIsFormFilled] = useState(
    location?.state?.isFormFilled ? location?.state?.isFormFilled : "all"
  );
  const isPast = true;
  const [age, setAge] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("");
  const [signUpType, setSignUpType] = useState("all");
  const [filterByAdmin, setFilterByAdmin] = useState("all");
  const [exportData, setExportData] = useState(true);
  const [newUsers, setNewUsers] = useState([]);
  const limit = 10;
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dateRangePickerKey, setDateRangePickerKey] = useState(1);
  const [exportLoader, setExportLoader] = useState(false);
  const didRunFilterEffectRef = useRef(false);

  function onDateChange(...args) {
    console.log(args, "args");
    setStartDate(moment(args[0]).format("YYYY-MM-DD"));
    {
      args[1]
        ? setEndDate(moment(args[1]).format("YYYY-MM-DD"))
        : setEndDate(null);
    }
  }
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const headers = [
    { label: "CONTACT ID", key: "_id" },
    { label: "EMAIL", key: "email" },
    { label: "FIRST NAME", key: "name" },
    { label: "LAST NAME", key: "" },
    { label: "SMS", key: "phoneNumber" },
  ];
  const getTableData = async (
    searchValue = search,
    page = currentPage,
    overrides = {},
  ) => {
    setLoader(true);
    try {
      const safeSearchValue =
        typeof searchValue === "string" ? searchValue : search;

      const effectiveAge = "age" in overrides ? overrides.age : age;
      const effectiveSelectedCountry =
        "selectedCountry" in overrides
          ? overrides.selectedCountry
          : selectedCountry;
      const effectiveType = "type" in overrides ? overrides.type : type;
      const effectiveStatus =
        "status" in overrides ? overrides.status : status;
      const effectiveFilterByAdmin =
        "filterByAdmin" in overrides
          ? overrides.filterByAdmin
          : filterByAdmin;
      const effectiveStartDate =
        "startDate" in overrides ? overrides.startDate : startDate;
      const effectiveEndDate =
        "endDate" in overrides ? overrides.endDate : endDate;

      const response = await getPremiumUserList(
        page,
        limit,
        effectiveAge,
        effectiveSelectedCountry,
        effectiveType,
        effectiveStatus,
        safeSearchValue,
        effectiveFilterByAdmin,
        effectiveStartDate,
        effectiveEndDate,
        isPast
      );
      setUsers(response.data.data.users);
      const total = response.data.data.count;
      setPageCount(Math.ceil(total / limit));
      setListLength(total);
      setLoader(false);
      setInitialFetch(false);
    } catch (error) {
      console.log(error, "error");
      setLoader(false);
    }
  };
  function onReset() {
    // setDateRangePickerKey((prev) => prev + 1);
    setStartDate(null);
    setEndDate(null);
  }
  const onDelete = async (id) => {
    setLoader(true);
    try {
      const response = await deleteUser(id);
      notifyTopRight(response.data?.message);
      getTableData(search, currentPage);
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const onAction = async (id) => {
    setLoader(true);
    try {
      const response = await blockUser(id);
      notifyTopRight(response.data?.message);
      getTableData(search, currentPage);
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  useEffect(() => {
    getTableData(search, currentPage);
  }, [currentPage]);

  useEffect(() => {
    if (!didRunFilterEffectRef.current) {
      didRunFilterEffectRef.current = true;
      return;
    }

    if (currentPage !== 0) {
      setCurrentPage(0);
      return;
    }

    getTableData(search, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    gender,
    selectedCountry,
    type,
    status,
    isFormFilled,
    signUpType,
    startDate,
    endDate,
    filterByAdmin,
  ]);

  const getTableDataSearch = async () => {
    if (currentPage !== 0) {
      setCurrentPage(0);
    }
    getTableData(search, 0);
  };

  const getDuration = (type, purchaseDate, expireDate) => {
    const diffInSeconds = expireDate - purchaseDate;
    const diffInDays = diffInSeconds / (60 * 60 * 24);
    if (type == "weekly") {
      return "1 Week";
    } else if (type == "monthly") {
      return "1 Month";
    } else if (type == "quarterly") {
      return "3 Months";
    } else if (type == "semi_annually") {
      return diffInDays <= 10 ? "Free Trial" : "6 Months";
    } else {
      return "-";
    }
  };

  function formatTimestamp(timestamp) {
    const isSeconds = String(timestamp).length === 10;
    const timestampInMilliseconds = isSeconds ? timestamp * 1000 : timestamp;
    return moment(timestampInMilliseconds).format("DD-MM-YYYY");
  }

  const fetchDataForExport = async () => {
    setExportLoader(true);
    try {
      const response = await getPremiumUserList(
        currentPage,
        10000,
        age,
        selectedCountry,
        type,
        status,
        search,
        filterByAdmin,
        startDate,
        endDate,
        isPast
      );
      const userData = response.data.data?.users;
      setExportLoader(false);

      exportToExcel(userData);
    } catch (error) {
      console.log(error, "error");
      setExportLoader(false);
      notifyError("Failed to fetch export data");
    }
  };

  const exportToExcel = (data) => {
    const formattedData = data.map((user) => ({
      "Contact ID": user._id,
      Email: user.email,
      Name: user.name,
      "Phone Number": `${user.countryCode || ""}${user.phoneNumber || ""}`,
      Age: user.age,
      "Referral Code": user.referralCodeUsed || "",
      "Start Date": user.subscription?.purchaseDate
        ? formatTimestamp(user.subscription.purchaseDate)
        : "",
      "End Date": user.subscription?.expireDate
        ? formatTimestamp(user.subscription.expireDate)
        : "",
      Duration: user.subscription?.subscriptionPeriod
        ? getDuration(user.subscription.subscriptionPeriod)
        : "",
      "Device Type": user.subscription?.deviceType
        ? user.subscription.deviceType.toUpperCase()
        : "",
    }));

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(formattedData);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Past Premium Users");

    XLSX.writeFile(workbook, "Past-Premium-Users.xlsx");
  };

  return loader ? (
    <Spinner />
  ) : (
    <>
      <div className="">
        {/* Top Section */}
        <div className="row g-3 align-items-end">
          {/* Search Input */}
          <div className="col-12 col-md-6 col-lg-3">
            <div className="mc-filter-field">
              <label className="form-label fw-semibold">Search</label>
              <div className="input-group mc-search-group">
                <input
                  type="search"
                  name="table_search"
                  className="form-control"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && getTableDataSearch()}
                />
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={getTableDataSearch}
                  aria-label="Search"
                >
                  <i className="fa fa-search" />
                </button>
              </div>
            </div>
          </div>

          {/* Age Filter */}
          <div className="col-12 col-md-6 col-lg-3">
            <div className="mc-filter-field">
              <label className="form-label fw-semibold">Age</label>
              <div className="input-group mc-search-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Age"
                  value={age}
                  onChange={(e) => {
                    setAge(e.target.value);
                    dispatch(ageFilterPost(e.target.value));
                  }}
                  onKeyDown={(e) => e.key === "Enter" && getTableDataSearch()}
                />
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={getTableDataSearch}
                  aria-label="Search by age"
                >
                  <i className="fa fa-search" />
                </button>
              </div>
            </div>
          </div>

          {/* Reset Filter */}
          <div className="col-12 col-md-6 col-lg-3">
            <div className="mc-filter-field">
              <label className="form-label fw-semibold">&nbsp;</label>
              <button
                className="btn btn-danger w-100"
                onClick={() => {
                  const resetOverrides = {
                    age: "",
                    selectedCountry: "",
                    type: "all",
                    status: "all",
                    filterByAdmin: "all",
                    startDate: null,
                    endDate: null,
                  };
                  dispatch(resetFilterPost());
                  setGender("all");
                  setIsFormFilled("all");
                  setStatus("all");
                  setSignUpType("all");
                  setSearch("");
                  setAge("");
                  setSelectedCountry("");
                  setType("all");
                  setFilterByAdmin("all");
                  onReset();
                  setCurrentPage(0);
                  getTableData("", 0, resetOverrides);
                }}
              >
                Reset Filter
              </button>
            </div>
          </div>

          {/* Export Button */}
          <div className="col-12 col-md-6 col-lg-3">
            <div className="mc-filter-field">
              <label className="form-label fw-semibold">&nbsp;</label>
              {exportLoader ? (
                <button className="btn btn-primary w-100" disabled>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                  />
                  Exporting...
                </button>
              ) : (
                <button
                  className="btn btn-primary w-100"
                  onClick={() => fetchDataForExport()}
                >
                  Export <i className="flaticon-381-send"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        {/* Filter Section */}
        <div className="row g-3 mt-3">
          {/* Duration Filter */}
          <div className="col-12 col-md-4 col-lg-3">
            <label className="form-label fw-semibold">Filter by Duration</label>
            <select
              className="form-control"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="all">All</option>
              <option value="weekly">1 Week</option>
              <option value="monthly">1 Month</option>
              <option value="quarterly">3 Months</option>
              <option value="semi_annually">6 Months</option>
            </select>
          </div>

          {/* Country Picker */}
          <div className="col-12 col-md-4 col-lg-3">
            <label className="form-label fw-semibold">Location</label>
            <CountryPicker
              selectedCountry={selectedCountry}
              setSelectedCountry={setSelectedCountry}
              onSelect={(name) => setSelectedCountry(name)}
            />
          </div>

          {/* Status Filter */}
          <div className="col-12 col-md-4 col-lg-3">
            <label className="form-label fw-semibold">Filter by Status</label>
            <select
              className="form-control"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="all">All</option>
              <option value="enable">Enabled</option>
              <option value="disable">Disabled</option>
              <option value="deactivate">Deactivated</option>
            </select>
          </div>

          {/* Member Type Filter */}
          <div className="col-12 col-md-4 col-lg-3">
            <label className="form-label fw-semibold">Member Type</label>
            <select
              className="form-control"
              value={filterByAdmin}
              onChange={(e) => setFilterByAdmin(e.target.value)}
            >
              <option value="all">All</option>
              <option value="admin">Free</option>
              <option value="pay">Paying</option>
              <option value="referral">Referral Code</option>
              <option value="vip">Vip</option>
            </select>
          </div>
        </div>
      </div>

      <Table responsive>
        <thead style={{ color: "black" }}>
          <tr>
            <th>
              <strong>Image</strong>
            </th>
            <th>
              <strong>NAME</strong>
            </th>
            <th>
              <strong>EMAIL</strong>
            </th>
            <th>
              <strong>PHONE NUMBER</strong>
            </th>
            <th>
              <strong>STATUS</strong>
            </th>
            <th>
              <strong>Created at</strong>
            </th>
            <th>
              <strong>Completed at</strong>
            </th>
            <th>
              <strong>Refferal Code</strong>
            </th>
            <th>
              <strong>Start Date</strong>
            </th>
            <th>
              <strong>End Date</strong>
            </th>
            <th>
              <strong>Duration</strong>
            </th>
            <th>
              <strong>Device</strong>
            </th>
            <th>
              <strong>Action</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          {users?.map((item, i) => (
            <tr
              key={i}
              onClick={() =>
                navigate("/member-details", {
                  state: {
                    data: item?._id,
                    selectedTab: "Past Members",
                    search: search,
                    page: currentPage,
                  },
                })
              }
              className="pointer"
              style={{
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              <td>
                <GenderAvatar
                  src={
                    item?.images[0]?.type === "video"
                      ? imgBaseURl + item?.images[0]?.thumbnailUrl
                      : item?.images[0]?.type === "image"
                        ? imgBaseURl + item?.images[0]?.url
                        : item?.images[0]?.url
                          ? imgBaseURl + item?.images[0]?.url
                          : dummmyImg
                  }
                  gender={item?.gender}
                  width={100}
                  height={80}
                  onClick={() => {
                    setImageForView(imgBaseURl + item?.images[0]?.url);
                    setView(true);
                  }}
                />
              </td>
              <td>{item?.name}</td>
              <td>{item?.email}</td>
              <td>
                {item.countryCode && "+" + item.countryCode} {item?.phoneNumber}
              </td>
              <td>
                {(() => {
                  if (status !== "all") {
                    if (status === "adminDeleted" && item?.isDeletedByAdmin) {
                      return (
                        <Badge bg="" className="badge-secondary">
                          Deleted by Admin
                        </Badge>
                      );
                    }
                    if (status === "delete" && item?.isDeleted) {
                      return (
                        <Badge bg="" className="badge-secondary">
                          Deleted
                        </Badge>
                      );
                    }
                    if (status === "disable" && item?.isBlocked) {
                      return (
                        <Badge bg="" className="badge-danger">
                          Disabled
                        </Badge>
                      );
                    }
                    if (status === "deactivate" && item?.isDeactivated) {
                      return (
                        <Badge bg="" className="badge-warning">
                          Deactivated
                        </Badge>
                      );
                    }
                    if (
                      status === "enable" &&
                      !item?.isDeletedByAdmin &&
                      !item?.isDeleted &&
                      !item?.isDeactivated &&
                      !item?.isBlocked
                    ) {
                      return (
                        <Badge bg="" className="badge-success">
                          Enabled
                        </Badge>
                      );
                    }
                  }

                  if (item?.isDeletedByAdmin) {
                    return (
                      <Badge bg="" className="badge-secondary">
                        Deleted by Admin
                      </Badge>
                    );
                  }
                  if (item?.isDeleted) {
                    return (
                      <Badge bg="" className="badge-secondary">
                        Deleted
                      </Badge>
                    );
                  }
                  if (item?.isBlocked) {
                    return (
                      <Badge bg="" className="badge-danger">
                        Disabled
                      </Badge>
                    );
                  }
                  if (item?.isDeactivated) {
                    return (
                      <Badge bg="" className="badge-warning">
                        Deactivated
                      </Badge>
                    );
                  }
                  return (
                    <Badge bg="" className="badge-success">
                      Enabled
                    </Badge>
                  );
                })()}
              </td>
              <td>{item?.createdAt ? moment(item?.createdAt).format("MMM Do YYYY, h:mm A") : ""}</td>
              <td>{item?.completedAt ? moment(item?.completedAt).format("MMM Do YYYY, h:mm A") : ""}</td>
              <td>{item?.referralCodeUsed}</td>

              <td>
                {item?.subscription?.purchaseDate
                  ? formatTimestamp(item?.subscription?.purchaseDate)
                  : ""}
              </td>
              <td>
                {item?.subscription?.expireDate
                  ? formatTimestamp(item?.subscription?.expireDate)
                  : ""}
              </td>
              <td>
                {item?.subscription?.subscriptionPeriod
                  ? getDuration(
                    item?.subscription?.subscriptionPeriod,
                    item?.subscription?.purchaseDate,
                    item?.subscription?.expireDate
                  )
                  : item?.subscription?.createdByAmdin
                    ? "Admin"
                    : ""}
              </td>
              <td>
                {item?.subscription?.deviceType
                  ? item?.subscription?.deviceType.toUpperCase()
                  : ""}
              </td>
              <td
                onClick={(event) => {
                  event.stopPropagation();
                }}
              >
                <Dropdown>
                  <Dropdown.Toggle
                    variant="info light"
                    className="light sharp btn btn-info i-false"
                  >
                    {svg1}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      onClick={() => {
                        navigate("/chat", {
                          state: {
                            data: item?._id,
                            selectedTab: "Past Members",
                            userName: item?.name,
                            search: search,
                            page: currentPage,
                            gender: item?.gender,
                            type: "table",
                            userType: "member",
                          },
                        });
                        dispatch(selectConversationNull(null));
                      }}
                    >
                      Chat
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      {users?.length === 0 && !loader && (
        <div className="justify-content-center d-flex my-5">
          Sorry, Data Not Found!
        </div>
      )}
      {users?.length !== 0 && (
        <div className="card-footer clearfix">
          <div className="d-block d-sm-flex justify-content-between align-items-center">
            <div className="dataTables_info">
              Showing {currentPage * limit + 1} to{" "}
              {listLength > (currentPage + 1) * limit
                ? (currentPage + 1) * limit
                : listLength}{" "}
              of {listLength} entries
            </div>
            <Pagination
              pageCount={pageCount}
              pageValue={currentPage}
              setPage={setCurrentPage}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default PremiumUserPastTable;
